export default __webpack_public_path__ + "static/Plots0010-a6063fa6adfca0b9a3c1d359cc1ccfd7.jpg";